import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { WizardModal } from '@comparethemarketau/manor-modal';
import { Carousel } from '@comparethemarketau/manor-carousel';
import { Button as ManorButton } from '@comparethemarketau/manor-button';
import { faAngleRight, faAngleLeft } from '@fortawesome/pro-regular-svg-icons';

const useStyles = createUseStyles((theme) => ({
    modalActions: {
        background: 'white',
        borderTopStyle: 'solid',
        borderWidth: theme.spacing.px,
        borderTopColor: theme.colors.primary200,
        padding: '1.6rem 2.4rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    modalPreviousButton: {
        margin: 0,
        padding: 0
    },
    modalNextButton: {
        margin: 0,
        padding: '1.4rem 1.73rem'
    },
    modalCompleteButton: {
        margin: 0,
        padding: '1.4rem 1.73rem'
    }
}));

const _HandoverWizardModal = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    const { visible, onCompeleted, cleanupState, pages, providerCode } = props;
    const ctmChatButton = document.getElementById('ctmChatButton');

    const [carouselIndex, setCarouselIndex] = useState(0);

    useEffect(() => {
        if (visible) {
            openModal();
        }
    }, [visible]);

    const handleComplete = () => {
        if (onCompeleted) {
            onCompeleted();
        }
        closeModal();
    };

    const openModal = () => {
        if (ctmChatButton && ctmChatButton.style.visibility) {
            ctmChatButton.style.visibility = 'hidden';
        }
    };

    const closeModal = () => {
        cleanupState(providerCode);
        if (ctmChatButton && ctmChatButton.style.visibility) {
            ctmChatButton.style.visibility = 'visible';
        }
    };

    const handleNext = () => {
        setCarouselIndex(carouselIndex + 1);
    };

    const handlePrevious = () => {
        setCarouselIndex(carouselIndex - 1);
    };

    const carouselActions = (pageCount) => {
        const leftButton = carouselIndex === 0 ? (
            <div style={{ width: '1rem' }} />
        ) : (
            <ManorButton
                id="carousel-previous-btn"
                variant="tertiary"
                className={classes.modalPreviousButton}
                handleClick={handlePrevious}
                icon={faAngleLeft}
                trackingLabel={'Previous button for hand-over-tracking'}
            >
                Previous
            </ManorButton>
        );

        const rightButton = carouselIndex === pageCount - 1 ? (
            <ManorButton
                id="carousel-complete-btn"
                variant="hero"
                className={classes.modalCompleteButton}
                handleClick={handleComplete}
                icon={faAngleRight}
                iconAlign="right"
                trackingLabel={'Complete button for hand-over-tracking'}
            >
                I Agree and Continue
            </ManorButton>
        ) : (
            <ManorButton
                id="carousel-next-btn"
                variant="primary"
                className={classes.modalNextButton}
                handleClick={handleNext}
                icon={faAngleRight}
                iconAlign="right"
                trackingLabel={'Next button for hand-over-tracking'}
            >
                Next
            </ManorButton>
        );

        return (
            <div className={classes.modalActions}>
                <div>{leftButton}</div>
                <div>{rightButton}</div>
            </div>
        );
    };

    return (
        <div className="test-handoverWizardModal">
            {pages
                && (
                    <WizardModal
                        id="handover-wizard"
                        trackingLabel="handover-wizard-tracking"
                        visible={visible}
                        onClose={closeModal}
                    >
                        <Carousel
                            id="handover-wizard-carousel"
                            trackingLabel="handover-wizard-carousel-tracking"
                            onActiveIndexChanged={setCarouselIndex}
                            carouselIndex={carouselIndex}
                        >
                            {pages}
                        </Carousel>
                        {carouselActions(pages.length)}
                    </WizardModal>
                )}
        </div>
    );
};

_HandoverWizardModal.propTypes = {
    onCompeleted: PropTypes.func,
    pages: PropTypes.array,
    providerCode: PropTypes.string,
    // from redux
    visible: PropTypes.bool,
    cleanupState: PropTypes.func.isRequired
};

const mapStateToProps = (state, { providerCode }) => {
    const customerHandover = state.getIn(['page', `customerHandoverModal_${providerCode}`]);
    return {
        visible: customerHandover
    };
};

const mapDispatchToProps = (dispatch) => ({
    cleanupState: (providerCode) => {
        dispatch({
            type: 'SET_PAGE_VALUE',
            identifier: `customerHandoverModal_${providerCode}`,
            value: false
        });
    }
});

const HandoverWizardModal = connect(mapStateToProps, mapDispatchToProps)(_HandoverWizardModal);

export { HandoverWizardModal };
